import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import React from 'react';
import { Modal, Button, Col, Form, Row, Spinner, Image } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import '../../App.css';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}
function quoteDateFormat(value, row, index) {
    if (row.QuoteAmount == 'Quote in Progress' || row.QuoteAmount == '') {
        return '';
    }
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class ContractorMainPage extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            contractor: props.location.state.contractor,
            data: historyExists ? props.location.state.data : [],
            filteredData: historyExists ? props.location.state.filteredData : [],
            selectedRecord: {},
            filterJobName: historyExists ? props.location.state.filterJobName : '',
            filterBidList: historyExists ? props.location.state.filterBidList :'all',
            loading: false,
            showModal:false,
        };

        console.log(this.state);

        this.handleClear = this.handleClear.bind(this);
        this.handleRequestAddRemove = this.handleRequestAddRemove.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.showButton = this.showButton.bind(this);
        this.loadingSpinner = this.loadingSpinner.bind(this);

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.updateHistory = this.updateHistory.bind(this);


        this.tableRef = React.createRef();
        this.jobNameText = React.createRef();
        this.bidListCombo = React.createRef();
        this.confirmModal = React.createRef();
    }

    componentDidMount() {
        //if (this.state.data.length == 0) {
            this.handleTableChange("None", this.state);
        //}
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleFilterChange(event) {
        let input = this.state;
        console.log(input);
        let filterJobName = this.state.filterJobName;
        let filterBidList = this.state.filterBidList;
        if (event != null) {
            if (event.target.name == 'filterJobName') {
                filterJobName = event.target.value;
            }
            else if (event.target.name == 'filterBidList') {
                filterBidList = event.target.value;

            }
        }

        let x = this.state.data.filter(function (ele) {
            return (filterJobName == '' || (ele.JobName != null && ele.JobName.toLowerCase().includes(filterJobName.toLowerCase()))) &&
                (filterBidList == 'all' || (filterBidList == 'on' && ele.OnBidList == true) || (filterBidList == 'off' && ele.OnBidList == false));
        });


        input.filteredData = x;
        input.filterJobName = filterJobName;
        input.filterBidList = filterBidList;
        this.setState({
            input
        }, () => this.updateHistory(input));
    }

    updateHistory(state) {
        this.props.history.replace({
            ...this.props.history.location,
            state: state
        });
    }

    handleClear(event) {
        event.preventDefault();
        this.jobNameText.current.value = '';
        this.bidListCombo.current.value = 'all';
        this.setState({
            filterJobName: '',
            filterBidList: 'all'
        }, () => this.handleFilterChange(null));
    }

    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
        this.handleTableChange("None", this.state);
    }

    handleRequestAddRemove(event) {
        let x = this.state.data.filter(x => x.Id == event.target.getAttribute('row_id'))[0];
        if (event.target.textContent.includes('Remove')) {
            this.props.history.push({
                pathname: '/request_remove',
                state: {
                    user: this.state.user,
                    contractor: this.state.contractor,
                    job: x
                }
            });
        }
        else {
            this.props.history.push({
                pathname: '/request_add',
                state: {
                    user: this.state.user,
                    contractor: this.state.contractor,
                    job: x
                }
            });
        }
    }

    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        ReactGA.event({
            category: 'Search',
            action: 'Contractor Main',
            label: 'Contractor Main Search'
        });
        this.setState({
            data: [],
            filteredData: [],
            loading: true
        }
            , function () {
                axios.get(`${Constants.apiURL}/api/Contractor/GetJobs`, {
                    params: {
                        //username: this.state.user.username,
                        contractor: this.state.contractor.Id
                    }
                }).then(response => {
                    if (response.data) {
                        console.log(response.data);
                        this.setState(() => ({
                            data: response.data,
                            filteredData: response.data,
                            loading: false
                        }), () => this.handleFilterChange(null));
                    }
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            }
       );
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }

    render() {
        const { filteredData, showModal } = this.state;

        const columns = [
            {
                dataField: 'BidDate',
                text: 'Bid Date',
                sort: true,
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'150px' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize: '18px'
                }
            },
            {
                dataField: 'JobName',
                text: 'Job Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize: '18px'
                }
            },
            {
                dataField: 'OnBidList',
                text: 'On Bid List?',
                sort:true,
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize: '18px'
                },
                formatter: function (cell, row) {
                    return <Form.Check style={{textAlign:'center'}} type='checkbox' disabled={true} checked={cell} />
                }
            },
            {
                dataField: 'temp',
                text: 'Add/Remove',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize: '18px'
                },
                formatter: (cell, row) => {
                    return (
                        <Button style={row.OnBidList ? { width: '100%', backgroundColor: '#EF4139' } : { width: '100%', backgroundColor: '#00973A' }}
                            row_id={row.Id} onClick={this.handleRequestAddRemove}>
                            {!row.OnBidList ? 'Add to Bid List' : 'Remove from Bid List'}
                        </Button>);
                }
            },
            {
                dataField: 'QuoteAmount',
                text: 'Quote Status',
                headerStyle: (colum, colIndex) => {
                    return { width:'180px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize:'18px'
                },
                formatter: (cell, row) => {
                    return (
                        <Form.Label style={cell == 'Quote in Progress' ? { fontStyle: 'italic', marginBottom: 0 } : { fontWeight: 'bold', marginBottom: 0 }}
                            row_id={row.Id} onClick={this.handleRequestDisable}>
                            {cell}
                        </Form.Label>);
                }
            },
            {
                dataField: 'DateQuoted',
                text: 'Quote Date',
                formatter: quoteDateFormat,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width: '150px' };
                },
                style: {
                    verticalAlign: 'middle',
                    fontSize: '18px'
                }
            }
        ];
        const defaultSorted = [{
            dataField: 'BidDate',
            order: 'asc'
        }];

        return (
            <div class='user_manager'>
                <Modal ref={this.confirmModal} show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Confirm removal of selected user from account.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="confirm" onClick={this.handleClose}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
                <SiteMenu user={this.state.user} currentPage='contractorMainPage' />
                <Row style={{paddingLeft:'12px'}}>
                    <Col>
                        <Form.Label style={{
                            paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', paddingTop: '10px'
                        }}>
                            {this.state.contractor.Name}</Form.Label><br/>
                        <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontSize: '15px' }}>
                            Below are jobs currently on Boland's bid list. You may add or remove your team from a job's bid list, or submit a new job if not shown below.</Form.Label>
                        <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontWeight:'bold',fontSize: '15px' }}>
                            Please contact your Boland salesperson regarding quotes.</Form.Label>
                    </Col>
                    <Col style={{ flex: .5, textAlign: 'right' }}>
                        <Image src="./Boland_Trane.png" fluid width="300px" height="auto" />
                    </Col>
                </Row>
                <Form.Group as={Row} style={{ padding: '10px 15px 0px 15px' }}>
                    <Col md="auto" style={{ paddingLeft:'7px'}} >
                        <Button style={{ backgroundColor: '#00973A', width: 'auto', marginLeft: 0 }} variant="primary" onClick={() => {

                            this.props.history.push({
                                pathname: '/new_job',
                                state: {
                                    user: this.state.user,
                                    contractor: this.state.contractor
                                }
                            });
                        }}>Submit New Job</Button>
                    </Col>

                    <Col md="auto" style={{ paddingLeft: '7px' }} >
                        <Button style={{ backgroundColor: '#00973A', width: 'auto', marginLeft: 0 }} variant="primary" onClick={() => {

                            this.props.history.push({
                                pathname: '/Contractor_Notification',
                                state: {
                                    user: this.state.user,
                                    contractor: this.state.contractor
                                }
                            });
                        }}>Add Notification Email</Button>
                    </Col>

                    <Col width='100%' className="filler-col"/>
                    <Col md="auto" className="mobile-p-l-10" style={{ paddingLeft: 0 }}>
                        <Form.Label style={{paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '7px'}}>Filter by bid list status:</Form.Label>
                    </Col>
                    <Col md="auto" className="mobile-p-l-10"  style={{ paddingLeft: 0 }}>
                        <Form.Select value={this.state.filterBidList} onChange={this.handleFilterChange} ref={this.bidListCombo} name="filterBidList" style={{ width: "200px" }}>
                            <option value="all">Show All</option>
                            <option value="on">On bid list</option>
                            <option value="off">Off bid list</option>
                        </Form.Select>
                    </Col>
                    <Col md="auto" className="mobile-p-t-10">
                        <Form.Control type="input" value={this.state.filterJobName} name="filterJobName" ref={this.jobNameText}
                            onChange={this.handleFilterChange} placeholder="Filter by job name..." />
                    </Col>
                    <Col md="auto" className="mobile-m-l-10 mobile-p-t-10" style={{ paddingLeft: 0 }} >
                        <Button type="button" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                    </Col>
                    <Col md="auto" className="mobile-m-l-10 mobile-p-t-10" style={{ paddingLeft: 0 }} >
                        <Button type="button" style={{ width: 'auto', marginLeft: 0 }} variant="primary" onClick={() => { this.handleTableChange('', {})}}>Refresh</Button>
                    </Col>
                </Form.Group>
                <div>
                    <BootstrapTable
                        bootstrap4
                        remote={{sort:false}}
                        id="contractor_jobs_table"
                        keyField="Id"
                        wrapperClasses="table-responsive contractor-main-table"
                        sort={true}
                        data={filteredData}
                        columns={columns}
                        onTableChange={this.handleTableChange}
                        totalSize={this.state.totalSize}
                        noDataIndication={this.loadingSpinner}
                        defaultSorted={defaultSorted}
                        noDataIndication={this.loadingSpinner}
                        loading={this.state.loading}
                        hover
                        ref={this.tableRef}
                    />
                </div>
            </div >
        );
    }
}

export default ContractorMainPage;